import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import 'react';
import 'reakit-system/useToken';
import 'color';
import './utils/isLight.js';
import { useContrast } from './utils/contrast.js';
import './palette.js';
import { usePalette } from './utils/palette.js';
import './utils/ref.js';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function useBoxProps(_ref2, _ref) {
  var _ref2$unstable_system = _ref2.unstable_system,
      system = _ref2$unstable_system === void 0 ? {} : _ref2$unstable_system;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref3 = _ref,
      htmlStyle = _ref3.style,
      htmlProps = _objectWithoutPropertiesLoose(_ref3, ["style"]);

  var color = usePalette(system.palette);
  var contrast = useContrast(color);
  var textColor = system.fill === "opaque" ? contrast : color;
  var backgroundColor = system.fill === "opaque" ? color : undefined;
  var borderColor = system.fill === "outline" ? color : undefined;

  var style = _objectSpread2({}, textColor ? {
    color: textColor
  } : {}, {}, backgroundColor ? {
    backgroundColor: backgroundColor
  } : {}, {}, borderColor ? {
    border: "1px solid " + borderColor,
    borderColor: borderColor
  } : {});

  return _objectSpread2({
    style: _objectSpread2({}, style, {}, htmlStyle)
  }, htmlProps);
}

export { useBoxProps };